/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Dec 2021
 * @flow
 */

import React from 'react';
import Button from '../../../../components/Button';
import Station from '../Station';
import classes from './Body.module.css';
import strings from '../../../../globalization';

const RightSection = props => {
  return (
    <div className={classes.rightSection}>
      <div className={classes.tablesWrapper}>
        {!props?.stationView ? <StationsView {...props} /> : <EmployeesView {...props} />}
      </div>
      <MergeButton
        stationView={props?.stationView}
        station={props.station}
        stationEmployees={props?.stationEmployees}
        employee={props?.employee}
        employeeStations={props?.employeeStations}
        onMerge={props?.onMerge}
      />
    </div>
  )
};

export default RightSection;

const StationsView = props => {
  const {
    stations,
    employee,
    employeeStations,
    setTableAssignment,
    tableWithSensors,
    sensorsObject,
    assigned,
    revenueCentersMap,
  } = props;

  const isVisible = stationProps => {
    const { station, employees } = stationProps;
    let sensorFlag = true, assignedFlag = true;

    if (tableWithSensors) {
      sensorFlag = (station.id && sensorsObject.hasOwnProperty([station.id])) ? true : false;
    }

    if (assigned) {
      assignedFlag = (Array.isArray(employees) && employees.length > 0);
    }

    return (sensorFlag && assignedFlag);
  };

  return (
    <>
      {!employee ? null :
        stations.map(eachStation => {
          const { station, employees } = eachStation;
          return (!isVisible(eachStation) ? null :
            <Station
              key={station.id}
              active={employeeStations.has(station.id)}
              station={station}
              isTableAssigned={(Array.isArray(employees) && employees.length > 0)}
              onClick={setTableAssignment}
              flexBasis={'30%'}
              revenueCentersMap={revenueCentersMap}
            />
          )
        })
      }
    </>
  );
};

const EmployeesView = props => {
  const {
    station,
    employees,
    stationEmployees,
    setEmployeeAssignment,
    excludeTerminated,
    jobAllowsAssignment,
    jobsMap,
    assigned,
  } = props;

  const isVisible = empProps => {
    const { employee, stations } = empProps;
    let terminatedFlag = true, jobTypeFlag = true, jobAllowsAssignmentFlag = true, assignedFlag = true;

    if (excludeTerminated) { //show only employees where terminated = false
      terminatedFlag = employee.terminated === false;
    }

    if (jobAllowsAssignment) { //show employees that have a job and job.allowEmployeeTableAssignment is true
      const empJob = jobsMap.has(employee.jobId) ? jobsMap.get(employee.jobId) : {};
      jobAllowsAssignmentFlag = empJob?.allowEmployeeTableAssignment === true ? true : false;
    }

    if (assigned) {
      assignedFlag = (Array.isArray(stations) && stations.length > 0);
    }

    return (terminatedFlag && jobAllowsAssignmentFlag && jobTypeFlag && assignedFlag);
  };

  return (
    <>
      {!station ? null :
        employees.map(eachEmployee => {
          const { employee } = eachEmployee;
          return (
            isVisible(eachEmployee)
              ? <Station
                key={employee.id}
                active={stationEmployees.has(employee.id)}
                isEmployee
                employee={employee}
                onClick={setEmployeeAssignment}
                flexBasis={'30%'}
              />
              : null
          )
        })
      }
    </>
  );
};

const MergeButton = props => {
  const { stationView, station, stationEmployees, employee, employeeStations, onMerge } = props;

  const isButtonDisabled = () => {
    if (stationView) {
      if (!!station && stationEmployees.size !== 0)
        return false;
      else return true;
    } else {
      if (!!employee && employeeStations.size !== 0)
        return false;
      else return true;
    }
  };

  return (
    <div className={classes.buttonsWrapper}>
      <Button className={classes.btn} onClick={onMerge} disabled={isButtonDisabled()}>
        <span className={classes.mergeTxt}>{strings.assign.toUpperCase()}</span>
      </Button>
    </div>
  );
};
